import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchAd = async (id) => {
  try {
    const response = await authClient.get(`/ad/${id}`);
    return { data: response.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju oglasa.'
    );
    return { data: null, error: message };
  }
};

export const fetchAds = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    Object.entries(filter || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== 'all') {
        if (Array.isArray(value)) {
          const joined = value.join(',');
          query += `&${key}=${encodeURIComponent(joined)}`;
        } else {
          query += `&${key}=${encodeURIComponent(value)}`;
        }
      }
    });

    if (search) {
      query += `&search=${search}`;
    }

    query += `&includeArchived=true`;

    const response = await authClient.get(`/ads${query}`);

    return {
      data: {
        ads: response.data.ads,
        page: response.data.page,
        totalPages: response.data.totalPages,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju oglasa.'
    );
    return { data: null, error: message };
  }
};

export const fetchUserAds = async ({
  page = 1,
  limit = 10,
  filter = {},
  userId,
}) => {
  if (!userId) {
    return {
      data: null,
      error: 'Nije prosleđen userId.',
    };
  }

  const updatedFilter = {
    ...filter,
    userId: userId,
  };

  return await fetchAds({ page, limit, filter: updatedFilter });
};

export const fetchAdCount = async () => {
  try {
    const response = await authClient.get(`/ads-count`);
    return { data: response.data.count, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju broja oglasa.'
    );
    return { data: null, error: message };
  }
};

export const createAd = async (formData, type = 'individual') => {
  try {
    const response = await authClient.post(`/ads-${type}`, formData);

    return {
      ad: response.data.newAd,
      message: response.data.message || 'Oglas uspešno kreiran.',
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri kreiranju oglasa.'
    );
    return { ad: null, message: null, error: message };
  }
};

export const updateAd = async (formData, ad, type = 'individual') => {
  try {
    const response = await authClient.patch(`/ad-${type}/${ad._id}`, formData);

    return {
      ad: response.data.updatedAd,
      message: response.data.message || 'Oglas uspešno ažuriran.',
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju oglasa.'
    );
    return { ad: null, message: null, error: message };
  }
};

export const changeAdStatus = async (status, adId) => {
  try {
    const response = await authClient.patch(`/ad-individual/${adId}`, {
      adStatus: status,
    });

    return {
      ad: response.data.updatedAd,
      message: response.data.message || 'Status oglasa uspešno ažuriran.',
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju statusa oglasa.'
    );
    return { ad: null, message: null, error: message };
  }
};

export const searchAds = async (searchQuery) => {
  try {
    const response = await authClient.patch(
      `/admin-ads-search?search=${encodeURIComponent(searchQuery)}`
    );

    return {
      ad: response.data.ad,
      message: response.data.message || 'Oglas uspešno ažuriran.',
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju oglasa.'
    );
    return { ad: null, message: null, error: message };
  }
};

export const fetchAdFeatures = async () => {
  try {
    const response = await authClient.get(`/ads-features`);
    return { data: response.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju osobina oglasa.'
    );
    return { data: null, error: message };
  }
};

export const deleteAd = async (id) => {
  try {
    const response = await authClient.delete(`/ad/${id}`);
    return {
      ad: response.data.deletedAd,
      message: response.data.message || 'Oglas uspešno obrisan.',
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri brisanju oglasa.'
    );
    return { data: null, error: message };
  }
};
